import {
  ArticleList,
} from "@babackapp/customer-ui/components/article";
import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
  SectionHeader,
  ShopLogo,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@babackapp/customer-ui/components/alert";
import { useDraftReturn } from "../hooks/use-draft-return";
import { useWidgetParams } from "../hooks/use-widget-params";
import { useCreateRetractationReturnRequest } from "../mutations/use-create-retractation-return-request";
import { usePublicOrder } from "../queries/use-public-order";
import { EnterIcon, ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { useNavigate } from "react-router-dom";
import { RetractationSummaryLineItem } from "./retractation-summary-line-item";

export function RetractationSummaryPage() {
  const { orderId, shopId, shopSlug, logoUrl } = useWidgetParams();
  const navigate = useNavigate();
  const draft = useDraftReturn(orderId);
  const { data: order } = usePublicOrder(orderId);
  const createReturnRequest = useCreateRetractationReturnRequest(orderId, shopSlug);

  const handleConfirm = async () => {
    if (!draft) return;
    const result = await createReturnRequest.mutateAsync(draft);
    navigate(`/return-widget/${shopId}/order/${orderId}/return-requests/${result?.id}`);
  };

  return (
    <WidgetPage>
      <Header>
        <ShopLogo src={logoUrl ?? undefined} />
        <HeaderTitle>Résumé de votre rétractation</HeaderTitle>
        <HeaderDescription>
          Vérifiez les articles sélectionnés avant de confirmer votre rétractation.
        </HeaderDescription>
      </Header>

      {createReturnRequest.isError && (
        <Alert variant="destructive">
          <ExclamationTriangleIcon />
          <AlertTitle>Échec de l'envoi de la rétractation</AlertTitle>
          <AlertDescription>
            Votre rétractation n'a pas pu être enregistrée. Vérifiez votre connexion et réessayez.
            Si le problème persiste, contactez le service client.
          </AlertDescription>
        </Alert>
      )}

      <div className="w-full mt-4 flex flex-col gap-6">
        {(draft?.lineItems ?? []).length > 0 && (
          <div className="flex flex-col gap-2">
            <SectionHeader>Articles retournés</SectionHeader>
            <ArticleList size="sm">
              {(draft?.lineItems ?? []).map((item) => (
                <RetractationSummaryLineItem
                  key={item.lineItemId}
                  item={item}
                  orderLineItems={order?.lineItems ?? []}
                />
              ))}
            </ArticleList>
          </div>
        )}
      </div>

      <AnimatedButtonRow variants={{}}>
        <AnimatedButtonContainer layoutId="line-item-confirm-button" variants={{}}>
          <Button
            size="lg"
            onClick={handleConfirm}
            disabled={!draft || createReturnRequest.isPending}
          >
            <EnterIcon />
            {createReturnRequest.isPending ? "Envoi en cours..." : "Confirmer la rétractation"}
          </Button>
        </AnimatedButtonContainer>
      </AnimatedButtonRow>
    </WidgetPage>
  );
}
